import { createSelector } from "reselect";

export const getCoinPrices = (state) => state.coinPrices;

export const getLatestPrice = createSelector(
  (state, { title }) => title,
  getCoinPrices,
  (coinName, coinPrices) => {
    const { lastPrices = {} } = coinPrices;
    return lastPrices[coinName].price || 0;
  },
);

export const getCurrentPrice = createSelector(
  (state, { title }) => title,
  getCoinPrices,
  (coinName, coinPrices) => {
    return coinPrices[coinName];
  },
);

export const selectCoinPrice = (coinName) => createSelector(
  getCoinPrices,
  (coinPrices) => coinPrices[coinName],
);

export const selectBodPrice = createSelector(
  (state, { coinName }) => coinName,
  getCoinPrices,
  (state) => state.UIState.tickerType,
  (coinName, coinPrices, tickerType) => {
    return coinPrices.bodPrices?.[tickerType]?.[coinName] ?? 0;
  }
);
